import * as React from 'react';
import { translate } from 'react-i18next';

export type TypeCustomField = {|
  custom_field_id: string,
  asset_custom_value?: any,
  contract_custom_value?: any,
  label: string,
  text_helper: string,
|};

const CustomFields: Function = (props: Object): React.Element<*> => {
  const {
    title,
    customFields,
    type = 'asset',
    t,
  }: { title: string, customFields: Array, t: Function } = props;
  const valueKey = `${type}_custom_value`;

  const renderFields = () => {
    return customFields.map(
      (item: TypeCustomField, key: number) =>
        item[valueKey] && (
          <tr key={key}>
            <td>
              <strong>{item.label}:</strong>
            </td>
            <td>{item[valueKey]}</td>
          </tr>
        )
    );
  };

  let fields = renderFields();
  fields = fields.filter(field => !!field);

  return (
    fields &&
    fields.length > 0 && (
      <React.Fragment>
        <h3>{title}</h3>
        <table>
          <tbody>{fields.map(field => field)}</tbody>
        </table>
      </React.Fragment>
    )
  );
};

export default translate()(CustomFields);
